import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

const IncomeItemDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("CreatedDate")} />
        </Col>
        <Col sm={6}>
          <NFLookupAccount fieldName={"accountId"} title={t("Account")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"analyticsTypeOfIncomeId"} title={t("Analytics Type of IncomeId")} />
        </Col>
      </Row>
    </>
  );
};

export default IncomeItemDetailMain;
